import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SwitchOverlayService } from './switch-overlay.service';

@Component({
  selector: 'switch-overlay',
  templateUrl: './switch-overlay.component.html',
  styleUrls: ['./switch-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SwitchOverlayComponent {
  readonly payload$ = this._service.payload$;

  constructor(private _service: SwitchOverlayService) {}
}
